import { createModel } from "nyax";
import { CustomPermissionRoleInfo } from "src/models/permissionSetting";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const RoleManagementEntityModel = createModel(
  class extends createItemsEntityModel<CustomPermissionRoleInfo>(
    (item) => item.id
  ) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
